module.exports = __webpack_public_path__ + "static/media/Frome_client_page_(optimized).9496c537.png";